import React from "react";
import { INextBestCoupon, ICouponCard } from "@swiggy-private/core-ui";

export interface CouponListingContextValue {
    isFetching: boolean;
    fetchCoupons: (params: {
        restaurantId: string;
        cartValue: number;
        dealCategory?: string;
        entityId?: string;
        isPartPaySelected?: boolean;
        tableId?: string;
    }) => void;
    isRemovingCoupon?: boolean;
    isApplyingCoupon?: boolean;
    errorMessage: string;
    clearErrorMessage: VoidFunction;
    couponsPayload: {
        data: ICouponCard[] | null;
        error?: {
            httpStatusCode?: number;
            errorPayload?: unknown;
        };
    };
    nextBestCoupon: INextBestCoupon | null;
    resetCouponListingPage: VoidFunction;
    hasInitiallyFetched: boolean;
}

export const CouponListingContext = React.createContext<CouponListingContextValue>({
    isFetching: false,
    couponsPayload: { data: null },
    errorMessage: "",
    isApplyingCoupon: false,
    clearErrorMessage: () => void 0,
    nextBestCoupon: null,
    fetchCoupons: () => void 0,
    resetCouponListingPage: () => void 0,
    hasInitiallyFetched: false,
});
